module.exports = __webpack_public_path__ + "media/images/lgt/lgt_2-5336a84ff255d77aea6d9f87d57e1c84.jpg";